<template>
<div id='diagram-buton' class='h-toolbarBg'>
    <ejs-toolbar>
        <e-items>
          <e-item :click="notices" eventType='saveLocBtn' v-if="saveLocBtn" :tooltipText='$t("Topo.saveTopo")' prefixIcon='icon hero-icon hero-icon-save'></e-item>
          <e-item :click="notices" eventType='excelLayout' v-if="layoutBtn" :tooltipText='$t("Topo.excelLayout")' prefixIcon='icon hero-icon hero-icon-layout'></e-item>
          <e-item :click="notices" eventType='revertScale' v-if="revertBtn" :tooltipText='$t("Topo.revertScale")' prefixIcon='icon hero-icon hero-icon-original-scale'></e-item>
          <e-item :click="notices" eventType='fullScreen' v-if="fullScreenBtn" :tooltipText='$t("Topo.fullScreen")' :prefixIcon='fullScreenIcon'></e-item>
          <e-item :click="notices" eventType='selectAll' v-if="selectAllBtn" :tooltipText='$t("Topo.selectAll")' prefixIcon='icon hero-icon hero-icon-Batch-select'></e-item>
          <e-item :click="notices" eventType='backPrevious' v-if="backPreBtn" :tooltipText='$t("Topo.backPrevious")' prefixIcon='icon hero-icon hero-icon-previous-layer'></e-item>
          <e-item :click="notices" eventType='refresh' v-if="refreshBtn" :tooltipText='$t("Alarm.refresh")' prefixIcon='icon hero-icon hero-icon-refresh'></e-item>
        </e-items>
    </ejs-toolbar>
</div>
</template>

<script>

export default {
    name: 'button-graph',
    props: {
      saveLocBtn: { type: Boolean, default: false },
      layoutBtn: { type: Boolean, default: false },
      revertBtn: { type: Boolean, default: false },
      fullScreenBtn: { type: Boolean, default: false },
      selectAllBtn: { type: Boolean, default: false },
      backPreBtn: { type: Boolean, default: false },
      refreshBtn: { type: Boolean, default: false },
    },
    mounted() {
    },
    data(){
      return{
        flag:1
      }
    },
    computed:{
      fullScreenIcon(){
        let icon = '';
        if(this.flag){
          icon = 'icon hero-icon hero-icon-full-screen';
        }else{
          icon = 'icon hero-icon hero-icon-Cancel-full-screen';
        }
        return icon;
      }
    },
    methods: {
        notices(args) {
            this.$emit('notice', args.item.eventType);
        },
    }
}
</script>
